"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDataForOrderPage = void 0;
class OrderDataForOrderPage {
}
exports.OrderDataForOrderPage = OrderDataForOrderPage;
//# sourceMappingURL=OrderDataForOrderPage.js.map